const DELIVER_KEY = 'mo_deliver_v1';
const NOTIF_KEY = 'mo_notif_prefs_v1';

const defaultNotif = () => ({
  systemPush: false,
  channels: { push: true, email: true, inApp: true }
});

export function getDeliverLocal() {
  try {
    const raw = localStorage.getItem(DELIVER_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function setDeliverLocal(prefs) {
  try {
    localStorage.setItem(DELIVER_KEY, JSON.stringify(prefs));
  } catch (_) {}
}

export function getNotifLocal() {
  try {
    const raw = localStorage.getItem(NOTIF_KEY);
    if (!raw) return defaultNotif();
    return { ...defaultNotif(), ...JSON.parse(raw) };
  } catch {
    return defaultNotif();
  }
}

export function setNotifLocal(prefs) {
  try {
    localStorage.setItem(NOTIF_KEY, JSON.stringify(prefs));
  } catch (_) {}
}

export function parseUserNotifPrefs(str) {
  if (!str) return null;
  try {
    return JSON.parse(str);
  } catch {
    return null;
  }
}
